"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getObjectSubset;
/**
 * Creates a new object with a subset of properties from `data` with the given `prefix`.
 * @param data Source object to create subset from.
 * @param prefix The prefix of the property name to query.
 * @returns An object with a subset of properties from `data`.
 */
function getObjectSubset(data, prefix) {
  return Object.keys(data).filter(function (key) {
    return key.indexOf(prefix) === 0;
  }).reduce(function (fresh, key) {
    fresh[key] = data[key];
    return fresh;
  }, {});
}